import { RECAPTCHA_SITE_KEY } from '../../enums';

export const recaptchaValidate = () => {
  return new Promise((resolve) => {
    window.grecaptcha.ready(function() {
      window.grecaptcha.execute(RECAPTCHA_SITE_KEY, {action: 'submit'}).then(function(token) {
          return resolve(token);
      });
    });
  })
}